var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 162,
    viewBox: "0 0 183 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 4,
    width: 168,
    height: 154,
    rx: 16,
    fill: "#C83333",
    stroke: "#C83333",
    strokeWidth: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 174,
    height: 156,
    rx: 19,
    fill: "white",
    stroke: "#C83333",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.354 113.331H102.608C101.006 113.331 99.7073 112.216 99.7073 110.841C99.7073 109.465 101.006 108.35 102.608 108.35H124.354C125.238 108.35 126.07 108.055 126.695 107.517C127.322 106.98 127.667 106.266 127.667 105.506V78.8329C127.667 77.4576 128.965 76.3427 130.567 76.3427C132.169 76.3427 133.467 77.4576 133.467 78.8329V105.506C133.467 107.598 132.519 109.563 130.796 111.04C129.077 112.517 126.788 113.331 124.354 113.331V113.331Z",
    fill: "#C7F6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.606 110.841H52.9004C51.2986 110.841 50 109.726 50 108.35V41.4902C50 40.115 51.2986 39 52.9004 39H102.606C104.208 39 105.507 40.115 105.507 41.4902V108.35C105.507 109.726 104.208 110.841 102.606 110.841Z",
    fill: "#C7F6D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.506 108.35V41.4902C105.506 40.115 104.207 39 102.606 39H77.7527V110.841H102.606C104.207 110.841 105.506 109.726 105.506 108.35Z",
    fill: "#92E3A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.885 59.9844C138.284 59.9844 136.985 58.8694 136.985 57.4942V41.4902C136.985 40.115 138.284 39 139.885 39C141.487 39 142.786 40.115 142.786 41.4902V57.4942C142.786 58.8696 141.487 59.9844 139.885 59.9844Z",
    fill: "#14AF78"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.245 59.9844C119.644 59.9844 118.345 58.8694 118.345 57.4942V41.4902C118.345 40.115 119.644 39 121.245 39C122.847 39 124.146 40.115 124.146 41.4902V57.4942C124.146 58.8696 122.847 59.9844 121.245 59.9844Z",
    fill: "#14A06F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1721 102.367C69.2291 101.934 68.6403 101.09 68.6403 100.171V91.9924H65.3275C64.0494 91.9924 62.9219 91.274 62.5516 90.2238C62.1814 89.1736 62.6553 88.0388 63.7187 87.4302L82.3584 76.7609C83.2484 76.2514 84.3927 76.2041 85.3357 76.6372C86.2787 77.0705 86.8675 77.9144 86.8675 78.8329V87.0119H90.1803C91.4584 87.0119 92.5859 87.7302 92.9562 88.7804C93.3264 89.8307 92.8525 90.9654 91.7891 91.574L73.1494 102.243C72.2599 102.753 71.1156 102.8 70.1721 102.367V102.367Z",
    fill: "#14AF78"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1802 70.6536H65.3274C63.7256 70.6536 62.427 69.5387 62.427 68.1634V53.493C62.427 52.1178 63.7256 51.0028 65.3274 51.0028H90.1802C91.782 51.0028 93.0806 52.1178 93.0806 53.493V68.1634C93.0806 69.5387 91.782 70.6536 90.1802 70.6536Z",
    fill: "#F5FAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.565 81.3231C120.385 81.3231 112.131 74.2518 112.131 65.4961V57.4942C112.131 56.1189 113.43 55.0039 115.032 55.0039H146.098C147.699 55.0039 148.998 56.1189 148.998 57.4942V65.4961C148.998 74.2354 140.763 81.3231 130.565 81.3231V81.3231Z",
    fill: "#92E3A9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9549 88.7806C92.5844 87.7304 91.4569 87.012 90.179 87.012H86.8662V78.8329C86.8662 77.9145 86.2774 77.0707 85.3344 76.6372C84.3914 76.2041 83.2471 76.2514 82.3571 76.7609L77.7527 79.3964V99.6078L91.7879 91.5742C92.8512 90.9655 93.3253 89.8308 92.9549 88.7806V88.7806Z",
    fill: "#14A06F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0796 68.1634V53.493C93.0796 52.1178 91.781 51.0028 90.1792 51.0028H77.7527V70.6536H90.1792C91.781 70.6536 93.0796 69.5387 93.0796 68.1634Z",
    fill: "#C7F6D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.606 124H52.9004C51.2986 124 50 122.885 50 121.51V108.35H105.507V121.51C105.507 122.885 104.208 124 102.606 124Z",
    fill: "#14AF78"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.506 121.51V108.35H77.7527V124H102.606C104.207 124 105.506 122.885 105.506 121.51Z",
    fill: "#14A06F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M146.1 55.0039H130.567V81.3229C140.765 81.3229 149 74.2352 149 65.496V57.4942C149 56.1189 147.701 55.0039 146.1 55.0039V55.0039Z",
    fill: "#14AF78"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF2);
export default __webpack_public_path__ + "static/media/f2.2150d71244febb12460667992b4ff1fa.svg";
export { ForwardRef as ReactComponent };